import { render, staticRenderFns } from "./CheckboxesCriterionInput.vue?vue&type=template&id=fc63a146"
import script from "./CheckboxesCriterionInput.vue?vue&type=script&lang=ts"
export * from "./CheckboxesCriterionInput.vue?vue&type=script&lang=ts"
import style0 from "./CheckboxesCriterionInput.vue?vue&type=style&index=0&id=fc63a146&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports